/*=========================================================================================
  File Name: store.js
  Description: Vuex store
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Vuex from 'vuex'

import state from './state'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'

Vue.use(Vuex)

//                                                                       unknown
// import moduleTodo from './todo/moduleTodo.js'
// import moduleCalendar from './calendar/moduleCalendar.js'
// import moduleChat from './chat/moduleChat.js'
// import moduleEmail from './email/moduleEmail.js'
import moduleAuth from './auth/moduleAuth.js'
import moduleECommerce from './eCommerce/moduleECommerce.js'
import moduleConst from './manage/const.js'
import moduleCategory from './category/index'
import moduleVariant from './variant/index'
import variantAdd from './variant/variant'
import moduleProduct from './product/index'
import moduleOrder from './order/index'
import moduleCustomer from './customer/customer'
import collection from './collection/collection'
import user from './user/user'
import blog from './blog/blog'
import adpackage from './adpackage/adpackage'
import shop from './store/shop'
import access from './access/access'
import adv from './advertisng/advertising'
import advModel from './adv/adv'
import badadv from './badadv/badadv'
import points from './point/points'
import transaction from './transaction/transaction'
import price from './price/price'
import route from './route'
//                                                                         unknown

//                                                                         sedmed known store
import contract from './contract/index'
//                                                                         sedmed known store

export default new Vuex.Store({
  getters,
  mutations,
  state,
  actions,
  modules: {
    auth: moduleAuth,
    const: moduleConst,
    category: moduleCategory,
    variant: moduleVariant,
    product: moduleProduct,
    order: moduleOrder,
    customer: moduleCustomer  ,
    eCommerce: moduleECommerce,
    collection:collection,
    user:user,
    blog:blog,
    adpackage:adpackage,
    shop:shop,
    access:access,
    adv:adv,
    badadv:badadv,
    points:points,
    transaction:transaction,
    price:price,
    variantAdd:variantAdd,
    advModel:advModel,
    route:route,

//                                                                         sedmed known store
    contract,
//                                                                         sedmed known store
  },
  strict: process.env.NODE_ENV !== 'production'
})
